export default "__VITE_ASSET__CPGoie0i__"